import { useQuery, queryOptions } from '@tanstack/react-query';

import { STALE_TIMES } from '#lib/queryConstants';

import { listTags } from '../../api/crmApi';

import { tagsKeys } from './keys';

export const tagsListOptions = (filters = { withUsage: true }) =>
	queryOptions({
		queryKey: tagsKeys.list(filters),
		queryFn: async () => listTags(filters),
		// Tag definitions rarely change within a session; every tag mutation invalidates
		// tagsKeys.all, so STABLE + invalidation keeps the multiselect/filter fresh.
		staleTime: STALE_TIMES.STABLE,
	});

export function useTags(filters = { withUsage: true }, { enabled = true } = {}) {
	return useQuery({ ...tagsListOptions(filters), enabled });
}
